export default __webpack_public_path__ + "static/product-3-desktop-c0f306328c270019055623aaa622ea53.png";